import { useState } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';

import { LpTitle } from '../atoms/LpTitle';
import { LpPlanTab } from './LpPlanTab';
import { LpPlanLimitedContents } from './LpPlanLimitedContents';
import { LpPlanCard } from './LpPlanCard';

// NOTE 単月プランを表示する場合はSUBSCRIPTION_PLANSを呼び出す
import { SUBSCRIPTION_PLANS_TEST, PlanType } from '../../../../const/Prices';

interface LpPlanListProps {
  type: string;
  forwardToSubscription?: boolean;
}

export const LpPlanList: React.FC<LpPlanListProps> = ({ type, forwardToSubscription }) => {
  const [currentPlan, setCurrentPlan] = useState<PlanType>('PREMIUM');

  return (
    <Container>
      <LpTitle>
        <h2>{type === 'lp' ? 'プラン料金' : 'プランを選択する'}</h2>
      </LpTitle>
      <Description>
        侍テラコヤでは契約期間に応じてお得になる価格設定となっています。
        <br />
        予定している期間に合ったプランを選択しましょう。
      </Description>

      <LpPlanTab currentPlan={currentPlan} setCurrentPlan={setCurrentPlan} />

      <PlanListArea type={type}>
        {SUBSCRIPTION_PLANS_TEST[currentPlan].map((plan) => {
          return (
            <LpPlanCard
              key={plan.id}
              id={plan.id}
              period={plan.period}
              price={plan.taxIncludedPrice}
              recommend={plan.recommend}
              forwardToSubscription={forwardToSubscription}
              type={type}
            />
          );
        })}
      </PlanListArea>

      <Note>
        ※12ヶ月、もしくは6ヶ月プランで途中解約をした場合、解約手数料が発生いたします。詳しくは
        <a href="https://tayori.com/q/samurai-terakoya/detail/876066/" target="_blank">
          こちら
        </a>
        。
      </Note>

      <StyledPlanLimitedContent plan={currentPlan} />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 4rem;

  ${media.lessThan('medium')`
    margin-top: 2.5rem;
  `}
`;
const Description = styled.p`
  margin: 1rem auto 4rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1.25rem;
  line-height: 1.4;
  text-align: center;

  ${media.lessThan('medium')`
    margin: 2rem auto;
    font-size: 1rem;
    line-height: 1.8;
  `}
`;
const PlanListArea = styled.div<{ type: string }>`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 3rem auto 0;
  ${(props) =>
    props.type === 'lp' &&
    `
    max-width: 640px;
  `}

  ${media.lessThan('medium')`
    gap: 1rem;
    max-width: 480px;
    margin: 2rem auto 0;
  `}
`;
const Note = styled.p`
  margin-top: 2rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;

  a {
    color: #eb0000;
    font-size: 1em;
    font-weight: 700;
    text-decoration: underline;
  }

  ${media.lessThan('medium')`
    margin-top: 1rem;
  `}
`;
const StyledPlanLimitedContent = styled(LpPlanLimitedContents)`
  margin-top: 4rem;

  ${media.lessThan('medium')`
    margin-top: 2.5rem;
  `}
`;
